import { apiSlice } from '../../api/apiSlice';

export const standardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStandardTree: builder.mutation({
      query: (options) => ({
        url: `Standard/Course/${options.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStandardDetails: builder.mutation({
      query: (params) => ({
        url: `Standard/Details?${params}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStandardsList: builder.mutation({
      query: (standard) => ({
        url: `QuestionSearch/StandardCrumbs/${standard}`,
        method: 'POST'
      })
    }),
  })
});

export const {
  useGetStandardTreeMutation,
  useGetStandardDetailsMutation,
  useGetStandardsListMutation
} = standardApi;